import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useTranslation } from 'react-i18next';

import { ResultSectionPanel } from '@vlabs/pages/checks/components/result-section-panel/ResultSectionPanel';

import type { BodySectionProps } from './types';
import { determinerAgeGroup } from './utils';
import { AttributeColor } from '../../../components/attribute-color/AttributeColor';
import { ResultItem } from '../../../components/result-item/ResultItem';

function BodySection({
  value,
}: BodySectionProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const attributes = value?.aggregated_estimations?.body?.attributes;
  if (!value?.aggregated_estimations?.body) return null;

  return (
    <ResultSectionPanel title={t('checks:check type card.video.tags.body attributes')}>
      <ResultItem label={t('gender')}>{EVENT_ENUMS.BODY_BASIC_ATTRIBUTES.APPARENT_GENDER[attributes.basic_attributes.apparent_gender]?.label}</ResultItem>
      <ResultItem label={t('возраст.title')}>{`${determinerAgeGroup(attributes.basic_attributes.apparent_age)?.label} (${t('ageCount', { count: attributes.basic_attributes.apparent_age })})`}</ResultItem>
      <ResultItem label={t('upper_body')}>
        <React.Fragment>
          {EVENT_ENUMS.UPPER_BODY.SLEEVE[attributes.upper_body.sleeve.length]?.label}
          <AttributeColor value={attributes.upper_body.upper_clothing.colors} />
        </React.Fragment>
      </ResultItem>
      <ResultItem label={t('lower_body')}>
        <React.Fragment>
          {EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE?.[attributes.lower_body.lower_garment.type]?.label}
          <AttributeColor value={attributes.lower_body.lower_garment.colors} />
        </React.Fragment>
      </ResultItem>
      <ResultItem label={t('backpack')}>{EVENT_ENUMS.ACCESSORIES.BACKPACK[attributes.accessories.backpack.state]?.label}</ResultItem>
      <ResultItem label={t('headwear')}>{EVENT_ENUMS.UPPER_BODY.HEADWEAR[attributes.upper_body.headwear.state]?.label}</ResultItem>
      <ResultItem label={t('footwear')}>
        <AttributeColor
          tooltip={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS[attributes.lower_body.shoes.apparent_color]?.label}
          value={attributes.lower_body.shoes.apparent_color}
        />
      </ResultItem>
    </ResultSectionPanel>
  );
}

export { BodySection };
